// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__9I+wz","skeleton-loading":"skeleton_skeleton-loading__V3OoS","overlay":"skeleton_overlay__ARs-U"};